import { render } from "./SetPreferences.vue?vue&type=template&id=2a3089ef"
import script from "./SetPreferences.vue?vue&type=script&lang=js"
export * from "./SetPreferences.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__